import z from "zod";

export const teacherEditFormSchema = z.object({
  email: z.string().refine((val) => /\S+@\S+\.\S+/.test(val), {
    message: "Please enter a valid email address",
  }),
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  preferredName: z.string().optional().nullable(),
  payRate: z
    .string()
    .min(1, { message: "Pay rate is required" })
    .refine((s) => !Number.isNaN(parseFloat(s)) && parseFloat(s) >= 0, {
      message: "Pay rate must be 0 or greater",
    }),
  biography: z.string().optional().nullable(),
  cellPhone: z.string().optional().nullable(),
  homePhone: z.string().optional().nullable(),
  payrollId: z.string().optional().nullable(),
  dateOfBirth: z.string().optional().nullable(),
  startDate: z
    .union([
      z.string(),
      z.object({ day: z.string(), month: z.string(), year: z.string() }),
    ])
    .optional()
    .nullable(),
  endDate: z
    .union([
      z.string(),
      z.object({ day: z.string(), month: z.string(), year: z.string() }),
    ])
    .optional()
    .nullable(),
  addressLine1: z.string().optional().nullable(),
  addressLine2: z.string().optional().nullable(),
  addressLine3: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  state: z.string().optional().nullable(),
  zip: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  isInContactUsMailingList: z.boolean().optional(),
  workLocationIds: z
    .array(z.number())
    .min(1, { message: "At least one location is required" }),
  isActive: z.boolean().optional(),
  isFeatured: z.boolean().optional(),
  classIds: z.array(z.number()).optional(),
  role: z.array(z.enum(["Teacher", "Staff", "Choreographer"])).min(1).optional(),
});

export type TeacherEditFormSchemaType = z.infer<typeof teacherEditFormSchema>;
